export const isPresentInArray = (array: any[], id: string) => {
  return array.findIndex((item: any) => item.id === id) >= 0;
};

export const getArrayIndex = (array: any[], id: string) =>
  array.findIndex((item: any) => item.id === id);

export const isArray = (array: any[]): boolean => {
  return Array.isArray(array);
};
